import type { List, Map as ImmutableMap } from 'immutable';

type PriorityImmutableMap = ImmutableMap<number, { priority: number; name: string }>;
type PriorityMap = Map<number, { priority: number; name: string }>;

// TODO: Использовать эти функции везде где есть приоритеты

export const sortIdsByPriority = <
  T extends number[] | List<number>, Items extends PriorityImmutableMap
>
  (itemIds: T, items: Items) => itemIds.sort((a, b) => {
    const firstItem = items.get(a);
    const secondItem = items.get(b);

    if (firstItem && secondItem) {
      const difference = secondItem.priority - firstItem.priority;

      if (difference !== 0) {
        return difference;
      }

      return firstItem.name.localeCompare(secondItem.name, 'en');
    }

    return -1;
  }) as T;

export const sortByPriority = <T extends PriorityImmutableMap>
  (items: T) => items.sort((a, b) => {
    const difference = b.priority - a.priority;

    if (difference !== 0) {
      return difference;
    }

    return a.name.localeCompare(b.name, 'en');
  });

export const sortByPriorityNative = <T extends PriorityMap>(items: T) => {
  const noData = {
    priority: 0,
    name: '',
  };

  return [...items.keys()].sort((itemId1, itemId2) => {
    const item1 = items.get(itemId1) || noData;
    const item2 = items.get(itemId2) || noData;

    const difference = item2.priority - item1.priority;

    if (difference !== 0) {
      return difference;
    }

    return item1.name.localeCompare(item2.name, 'en');
  });
};
